import React, { useState, useEffect } from "react"
import Flatpickr1 from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { Container, Row, Card, CardBody, Col, Table, Button, Input, CardTitle } from "reactstrap"
import moment from "moment"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import * as _ from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

import * as backend from "../../helpers/backend_helper"
import { accessFlags, canValidateReport } from "../../common/accessFlags"
import Toaster from "../../components/Common/Toaster"
import MwSelect from "../../components/Common/MwSelect"
import ImageViewer from "../../common/ui/ImageViewer"
import ReportValidationControls from "../../components/Common/ReportValidation"

// Daily Monitoring — Document Review.
// Headers: S# | Description | Status | Target Time (Y/N → set time) | Upload Document
// Documents can be assigned to specific users in config; non-admins only see the
// documents assigned to them, admins see all.
const Flatpickr: any = Flatpickr1

const DailyDocumentReview = (props: any) => {
  const today = moment().format("YYYY-MM-DD")
  const [date, setDate] = useState(today)
  const [reports, setReport] = useState<any[]>([])
  const [downloading, setDownloading] = useState(false)
  const [submitedBy, setSubmitedBy] = useState<any>({})
  const [validation, setValidation] = useState<any>(null)
  const [imageViewerData, setimageViewerData] = useState<any>(null)
  // Per-document ✓/✗ validation shown inline in the table (like Daily Work).
  const [itemState, setItemState] = useState<{ [id: string]: "yes" | "no" | undefined }>({})
  useEffect(() => { setItemState((validation && validation.items) || {}) }, [validation])
  const decided = !!(validation && validation.status)
  const canValidateThis = canValidateReport(props.selectedFactory, props.user, "dailydocument", submitedBy && submitedBy.id)
  const showItemCol = (canValidateThis && !!submitedBy.name) || decided
  const setItem = (id: string, v: "yes" | "no") =>
    setItemState((s) => ({ ...s, [id]: s[id] === v ? undefined : v }))
  const renderCheck = (id: string) => {
    const cur = itemState[id]
    if (decided) {
      if (!cur) return <span className="text-muted">—</span>
      return cur === "yes"
        ? <span style={{ color: "#1c8577", fontWeight: 800 }} title="OK">✓</span>
        : <span style={{ color: "#c0392b", fontWeight: 800 }} title="Issue">✗</span>
    }
    return (
      <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
        <button type="button" title="OK" onClick={() => setItem(id, "yes")}
          style={{ border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 9px", fontWeight: 800,
            background: cur === "yes" ? "#2ea99b" : "#eef1f4", color: cur === "yes" ? "#fff" : "#556" }}>✓</button>
        <button type="button" title="Issue" onClick={() => setItem(id, "no")}
          style={{ border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 9px", fontWeight: 800,
            background: cur === "no" ? "#e07a6f" : "#eef1f4", color: cur === "no" ? "#fff" : "#556" }}>✗</button>
      </div>
    )
  }

  const config = () =>
    JSON.parse(JSON.stringify(props.selectedFactory && props.selectedFactory.dailyDocumentReview
      ? props.selectedFactory.dailyDocumentReview
      : []))

  useEffect(() => {
    if (props.selectedFactory && props.selectedFactory.dailyDocumentReview) getReport(date)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedFactory && props.selectedFactory._id])

  const getReport = async (activeDate: string) => {
    if (!(props.selectedFactory && props.selectedFactory.dailyDocumentReview)) return
    const { orgId, _id: facId } = props.selectedFactory
    try {
      const data: any = await backend.getDailyDocumentReview(orgId, facId, activeDate)
      // Target time is defined in the factory config; always show the CONFIGURED
      // value (read-only) even for already-submitted rows, ignoring anything a
      // report may have stored earlier when it was still editable.
      const cfg = config()
      const cfgTarget: { [key: string]: any } = {}
      cfg.forEach((g: any) => (g.lists || []).forEach((l: any) => {
        cfgTarget[`${g.name}::${l.name}`] = { targetTime: l.targetTime, targetTimeValue: l.targetTimeValue }
      }))
      // Overlay per document point (groups → lists), keyed by group + point name.
      const applyTarget = (groups: any[]) => (groups || []).map((g: any) => ({
        ...g,
        lists: (g.lists || []).map((l: any) => {
          const c = cfgTarget[`${g.name}::${l.name}`]
          return c ? { ...l, ...c } : l
        }),
      }))
      if (data && data.lists) {
        const submittedNames = new Set((data.lists || []).map((l: any) => l.name))
        const clonedArray = cfg.filter((c: any) => !submittedNames.has(c.name))
        setReport(applyTarget([...data.lists, ...clonedArray]))
        setSubmitedBy(data.submitedBy || {})
        setValidation(data.validation || null)
      } else {
        setReport(applyTarget(cfg))
        setSubmitedBy({})
        setValidation(null)
      }
    } catch (e) {
      setReport(config())
      setSubmitedBy({})
    }
  }

  const canSeeDoc = (list: any) => {
    if (props.isAdmin) return true
    const assigned = list && list.assignedUsers
    if (!assigned || assigned.length === 0) return true
    return assigned.includes(props.user && props.user["_id"])
  }

  function setValue(oId: number, idx: number, value: any, key: string) {
    const cloneReports = [...reports]
    const list = cloneReports[oId].lists[idx]
    if (list) list[key] = value
    setReport([...cloneReports])
  }

  async function uploadFile(file: any, oId: number, idx: number) {
    try {
      const formData = new FormData()
      formData.append("image", file)
      const data: any = await backend.fileuploadAPI(formData)
      if (data.data.data && data.data.data[0]) {
        const _data = data.data.data[0]
        setValue(oId, idx, _data.id, "image")
        setValue(oId, idx, _data.mimetype, "mimeType")
      }
    } catch (err) {
      console.log("uploadFile", err)
    }
  }
  async function deleteFile(id: any) {
    try { await backend.fileuploaddeleteAPI(id) } catch (err) { console.log(err) }
  }

  async function submit() {
    const { orgId, _id: facId } = props.selectedFactory
    const data = { reports: reports, submitedBy: { name: props.user.name, id: props.user["_id"] } }
    try {
      await backend.saveDailyDocumentReview(orgId, facId, date, data)
      Toaster.success("Document Review Update Success")
      getReport(date)
    } catch (e) {
      Toaster.error("Document Review Update Failed")
    }
  }

  const downloadPdf = async () => {
    setDownloading(true)
    try {
      const { orgId, _id: facId } = props.selectedFactory
      await backend.downloadReportPdf(
        orgId,
        facId,
        "dailydocument",
        date,
        `Daily Document Review - ${String(date).split("-").reverse().join("")}.pdf`
      )
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Download failed")
    } finally {
      setDownloading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mw-page-header">
            <div className="mw-page-title">
              <h4>Document Review</h4>
              <p>{props.selectedFactory ? props.selectedFactory.name : "Factory"} — Daily Monitoring Documents</p>
            </div>
            <div style={{ width: 220 }}>
              <Flatpickr
                className="form-control d-block"
                value={date}
                options={{ dateFormat: "Y-m-d" }}
                onChange={(dates: any) => {
                  if (dates && dates[0]) {
                    const d = moment(dates[0]).format("YYYY-MM-DD")
                    setDate(d)
                    getReport(d)
                  }
                }}
              />
            </div>
          </div>

          {submitedBy.name && (
            <p className="text-muted" style={{ marginLeft: 4 }}>
              Submit By : <strong>{submitedBy.name}</strong>
            </p>
          )}

          <div style={{ marginBottom: 16, display: "flex", gap: 8 }}>
            {reports.length > 0 && !props.readOnly && (
              <Button onClick={submit} color="success">Submit</Button>
            )}
            {submitedBy.name && (
              <Button onClick={downloadPdf} disabled={downloading} color="success">
                {downloading ? "Preparing…" : "Download PDF"}
              </Button>
            )}
          </div>

          {/* Admin review: Validate / Reject with per-document ✓ / ✗ */}
          {submitedBy.name && (
            <div style={{ marginBottom: 16 }}>
              <ReportValidationControls
                reportType="dailydocument"
                dateKey={date}
                orgId={props.selectedFactory.orgId}
                facId={props.selectedFactory._id}
                validation={validation}
                isAdmin={canValidateThis}
                submitted={!!submitedBy.name}
                by={{ id: props.user && props.user["_id"], name: props.user && props.user.name }}
                onChange={setValidation}
                externalItems={itemState}
              />
            </div>
          )}

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {reports &&
              reports.map((report: any, oId: number) => {
                let sno = 0
                const hasVisible = (report.lists || []).some((l: any) => !l.isHeader && canSeeDoc(l))
                if (!hasVisible) return null
                return (
                  <Col lg={12} key={oId} style={{ marginBottom: 24 }}>
                    <Card>
                      <CardBody>
                        <CardTitle style={{ textAlign: "center", color: "#1D3A5F" }}>
                          {report.name}
                        </CardTitle>
                        <div className="table-responsive">
                          <Table className="table mw-table table-bordered mb-0">
                            <thead>
                              <tr>
                                <th>S#</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Target Time</th>
                                <th>Upload Document</th>
                                {showItemCol && <th>Check</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {report.lists.map((list: any, idx: number) => {
                                if (!list.isHeader && !canSeeDoc(list)) return null
                                if (!list.isHeader) sno = sno + 1
                                if (list.isHeader) {
                                  return (
                                    <tr key={idx} className="table-info" style={{ textAlign: "center" }}>
                                      <th colSpan={showItemCol ? 6 : 5} scope="row">{list.name}</th>
                                    </tr>
                                  )
                                }
                                return (
                                  <tr key={idx}>
                                    <th scope="row">{sno}</th>
                                    <td>{list.name}</td>
                                    <td style={{ minWidth: 120 }}>
                                      <MwSelect
                                        value={list.value || ""}
                                        placeholder="Select"
                                        onChange={(val: any) => setValue(oId, idx, val, "value")}
                                        options={[
                                          { value: "yes", label: "Yes" },
                                          { value: "no", label: "No" },
                                          { value: "na", label: "NA" },
                                        ]}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center", minWidth: 120 }}>
                                      {/* Read-only: the target time is set in the
                                          factory configuration, not here. */}
                                      {list.targetTime === "yes" && list.targetTimeValue
                                        ? <strong>{list.targetTimeValue}</strong>
                                        : <span className="text-muted">—</span>}
                                    </td>
                                    <td style={{ textAlign: "center", minWidth: 140 }}>
                                      {list.image ? (
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8 }}>
                                          <span
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setimageViewerData({ image: list.image, mimeType: list.mimeType })}
                                          >
                                            {list.mimeType !== "application/pdf" ? (
                                              <img src={list.image} alt="" width="42" height="42" />
                                            ) : (
                                              <i style={{ fontSize: 34, color: "green" }} className="bx bxs-file-pdf" />
                                            )}
                                          </span>
                                          <i
                                            style={{ cursor: "pointer", color: "red", fontSize: 20 }}
                                            className="bx bx-trash-alt"
                                            onClick={() => { deleteFile(list.image); setValue(oId, idx, "", "image") }}
                                          />
                                        </div>
                                      ) : (
                                        <div>
                                          <input
                                            style={{ display: "none" }}
                                            type="file"
                                            accept="image/jpeg, image/png,.pdf,.doc"
                                            id={`ddr-file-${oId}-${idx}`}
                                            onChange={(e: any) => {
                                              const file = e.target.files[0]
                                              if (!file) return
                                              const kb = Math.round(file.size / 1024)
                                              if (kb >= 4096) {
                                                toastr.options = { positionClass: "toast-top-right", timeOut: 5000, closeButton: true } as any
                                                toastr.error("File too Big, please select a file less than 4 mb")
                                              } else {
                                                uploadFile(file, oId, idx)
                                              }
                                            }}
                                          />
                                          <label
                                            style={{ border: "1px solid #ced4da", padding: "6px 10px", borderRadius: 6, cursor: "pointer", marginBottom: 0 }}
                                            htmlFor={`ddr-file-${oId}-${idx}`}
                                          >
                                            Choose file
                                          </label>
                                        </div>
                                      )}
                                    </td>
                                    {showItemCol && (
                                      <td style={{ textAlign: "center", verticalAlign: "middle" }}>{renderCheck(list.name)}</td>
                                    )}
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )
              })}
            {imageViewerData && (
              <ImageViewer filedata={imageViewerData} close={() => setimageViewerData("")} />
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state: any) => {
  const { user } = state.user
  const { selected: selectedFactory } = state.factory
  return { selectedFactory, user, ...accessFlags(selectedFactory) }
}

export default withRouter(connect(mapStateToProps, {})(DailyDocumentReview))
